/**
 * Removal of the in-page splash painted by `public/index.html` (N31).
 *
 * The splash is markup in the initial HTML, not a React component, because it
 * has to be on screen before the bundle parses. React's only job is to take it
 * away, and to take it away *from the DOM*: the previous failure mode that this
 * replaces was a layer that faded to nothing and stayed there, swallowing
 * clicks over the whole viewport for the rest of the session.
 *
 * Timings come from N31: 320ms opacity with `--ease-out` plus the bee at
 * scale(.96); 150ms fade with no scale under `prefers-reduced-motion`. The CSS
 * owns both — this file only has to know how long to wait before removing.
 */

const EXIT_MS = 320;
const EXIT_MS_REDUCED = 150;

let dismissed = false;

export function dismissSplash() {
  // Effects can run twice under StrictMode; the node is gone after the first.
  if (dismissed) return;
  const el = document.getElementById("fd-splash");
  if (!el) return;
  dismissed = true;

  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const remove = () => el.remove();

  // One frame so the browser paints the app underneath before the fade starts;
  // without it the transition is set on the same frame the attribute lands and
  // the splash can jump straight to transparent.
  requestAnimationFrame(() => {
    el.setAttribute("data-leaving", "");
    // `transitionend` is the accurate signal, and the timeout is the one that
    // has to be right: it fires whether or not the transition ever runs (a
    // backgrounded tab does not emit transitionend).
    el.addEventListener("transitionend", remove, { once: true });
    window.setTimeout(remove, (reduced ? EXIT_MS_REDUCED : EXIT_MS) + 60);
  });
}
